'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n'], ['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GridSizer = _styledComponents2.default.div(_templateObject);

/** @class GridSizer
  * An empty component used to set the size of a masonry grid.
  */
exports.default = GridSizer;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/grid-sizer.js
// module id = 664
// module chunks = 0